let cached: boolean | null = null

// True when this browser can create a WebGL context. Only call this from effects or handlers.
export const supportsWebGL = (): boolean => {
    if (cached !== null) return cached
    if (typeof window === 'undefined') return false

    try {
        const canvas = document.createElement('canvas')
        const context = (canvas.getContext('webgl2') ?? canvas.getContext('webgl')) as WebGLRenderingContext | null

        cached = Boolean(context)
        context?.getExtension('WEBGL_lose_context')?.loseContext()
    }
    catch {
        cached = false
    }

    return cached
}

export type DeviceQuality = 'high' | 'medium' | 'low'

// Rough device tier from cores, memory and screen size, used to pick 3D detail levels.
export const detectQuality = (): DeviceQuality => {
    if (typeof navigator === 'undefined') return 'medium'

    const cores = navigator.hardwareConcurrency || 4
    const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 4
    const shortSide = Math.min(window.screen.width, window.screen.height)
    const coarse = window.matchMedia('(pointer: coarse)').matches

    if (cores <= 4 || memory <= 3) return 'low'
    if (coarse || shortSide < 700 || cores <= 6) return 'medium'

    return 'high'
}

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false

    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
